import gql from 'graphql-tag';

const MOBILE_LEAD_LIST_FRAGMENT = gql`
	fragment mobileLeadList on Lead {
		id
		name
		status
		suburb
		state
		created
		nextFollowUpAt
		assignee {
			id
			firstname
			lastname
			username
		}
	}
`;

const MOBILE_LEAD_DETAIL_FRAGMENT = gql`
	fragment mobileLeadDetail on Lead {
		...mobileLeadList
		message
		companySize
		lastContactAt
		person {
			id
			name
			role
			phoneNumber
			email
		}
		secondaryPerson {
			id
			name
			role
			phoneNumber
			email
		}
		notes {
			id
			description
			created
			creator {
				id
				firstname
				lastname
				username
				destroyed
			}
		}
		photos {
			id
			link
			comment
		}
	}
	${MOBILE_LEAD_LIST_FRAGMENT}
`;

export const GET_MOBILE_LEADS = gql`
	query getMobileLeads(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: LeadPageFilter
	) {
		getLeads(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...mobileLeadList
			}
			count
		}
	}
	${MOBILE_LEAD_LIST_FRAGMENT}
`;

export const GET_MOBILE_LEAD = gql`
	query getMobileLead($id: String) {
		getLead(id: $id) {
			...mobileLeadDetail
		}
	}
	${MOBILE_LEAD_DETAIL_FRAGMENT}
`;

export const GET_MOBILE_LEAD_ASSIGNEES = gql`
	query getMobileLeadAssignees(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: UserPageFilter
	) {
		getUsers(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				firstname
				lastname
				username
			}
			count
		}
	}
`;

export const MODIFY_MOBILE_LEAD = gql`
	mutation modifyMobileLead($input: ModifyLeadInput!) {
		modifyLead(input: $input) {
			lead {
				...mobileLeadDetail
			}
		}
	}
	${MOBILE_LEAD_DETAIL_FRAGMENT}
`;

export const CREATE_MOBILE_LEAD = gql`
	mutation createMobileLead($input: CreateLeadInput!) {
		createLead(input: $input) {
			id
		}
	}
`;
